import React from 'react';

interface LazyImageProps {
  src: string;
  alt: string;
  className?: string;
  width?: number;
  height?: number;
  itemProp?: string;
}

/**
 * LazyImage component that implements lazy loading for better performance
 */
export function LazyImage({ 
  src, 
  alt, 
  className = '', 
  width, 
  height,
  itemProp
}: LazyImageProps) {
  return (
    <img 
      src={src} 
      alt={alt} 
      className={className} 
      loading="lazy" 
      width={width} 
      height={height}
      itemProp={itemProp}
    />
  );
}